import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { PreloaderService } from '../services/preloader.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  contentType;
  constructor(
    public route: Router,
    private auth: AuthService,
    private storage: StorageService,
    private preload: PreloaderService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has('Content-Type')) {
      this.contentType = request.headers.get('Content-Type');
    }
    // add authorization header with jwt token if available
    const currentUser = this.auth.user$.value;
    const token = this.auth.token$.value;
    if (currentUser && token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          appInfo: JSON.stringify(this.preload.appInfo),
          deploymentType: this.preload.deploymentType,
        },
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          // do error handling here
          if (error.status === 500) {
            if (error.message === 'Unauthenticated') {
              this.route.navigate(['/login']);
            }
          }
          if (error.status === 401) {
            this.auth.logout();
          }
        }
        return throwError(error);
      })
    );
  }
}
